import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2496a1aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2496a1aa&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=2496a1aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2496a1aa",
  null
  
)

export default component.exports